import React from 'react';

const statusConfig = {
  pending_confirmation: { label: 'PENDING', className: 'status-pending' },
  confirmed: { label: 'CONFIRMED', className: 'status-confirmed' },
  in_transit: { label: 'IN TRANSIT', className: 'status-in-transit' },
  delivered: { label: 'DELIVERED', className: 'status-delivered' },
  active: { label: 'ACTIVE', className: 'status-active' },
  inactive: { label: 'INACTIVE', className: 'status-inactive' },
};

export default function StatusBadge({ status, size = 'md' }) {
  const config = statusConfig[status] ?? { label: String(status).toUpperCase(), className: 'status-confirmed' };
  const sizeClass = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-xs';

  return (
    <span
      className={`${config.className} ${sizeClass} font-heading tracking-stamp inline-block`}
      style={{ fontFamily: 'var(--font-heading)', letterSpacing: '0.06em' }}
    >
      {config.label}
    </span>
  );
}
